import React from 'react'

export default function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 25" {...props}>
      <path
        fill="var(--svg-color-main, black)"
        d="m2.901 13.13 7.02-2.087v10.11l-5.087 1.442a1.506 1.506 0 0 1-1.933-1.442z"
        opacity="0.4"
      ></path>
      <path
        fill="var(--svg-color-main, black)"
        d="M18.16 21.155H9.92V11.043l1.87-8.443h.055c1.152 0 2.087.934 2.087 2.087v5.435h5.77a2.253 2.253 0 0 1 2.191 2.77L20.35 19.42a2.25 2.25 0 0 1-2.19 1.734"
      ></path>
    </svg>
  )
}
